<div id="dialog_container" class="small-dialog-container">
  <div id="upper_band" class="upper-band upper-band-color"></div>
  <div id="middle_band" class="center-band center">
    <img
      id="warning_icon"
      src="/assets/images/warning-icon.svg"
      alt="Warning"
      width="100"
      class="image-icon" />
    <span class="text-content">
      <div id="title" class="title">{{ title() }}</div>
      <div id="message" class="message" [innerHTML]="message()"></div>
    </span>
  </div>
  <hr class="custom-hr" />
  <div id="lower_band" class="lower-band">
    <button mat-button id="confirm_button" class="blue-button common-button" (click)="confirm()">
      {{ buttonConfirm() }}
    </button>
    <button mat-button id="cancel_button" class="white-button common-button" (click)="cancel()">
      {{ buttonCancel() }}
    </button>
  </div>
</div>
